// Light or dark, per device (public/theme.js applies it before the page paints).
// The design system switches on data-theme="dark" on <html>.
export type ThemeChoice = "system" | "light" | "dark";

const KEY = "convenor-theme";
const darkQuery = () => (typeof window.matchMedia === "function" ? window.matchMedia("(prefers-color-scheme: dark)") : null);

export function readTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(choice: ThemeChoice) {
  const dark = choice === "dark" || (choice === "system" && !!darkQuery()?.matches);
  document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
}

export function saveTheme(choice: ThemeChoice) {
  try {
    if (choice === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // Private windows may refuse storage: the choice then lasts until the page reloads.
  }
  applyTheme(choice);
}

/** Follows the device when it switches between light and dark, unless the person chose one. */
export function followDeviceTheme() {
  darkQuery()?.addEventListener?.("change", () => {
    if (readTheme() === "system") applyTheme("system");
  });
}
